// directives/intersect.js
import Vue from 'vue'
export default {
  inserted (el, binding, vnode) {
    const vm = vnode.context

    vm.$nextTick(() => {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      }
      let firstCheck = true
      let widget = Vue.ls.get('lastWidgetId')

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (widget && widget.isNavigateFromInfinite) {
            const scrollY = window.scrollY || window.pageYOffset
            const viewportH = window.innerHeight
            const docH = document.documentElement.scrollHeight

            const scrollPercent = ((scrollY + viewportH) / docH) * 100
            const el = document.getElementById(widget.id)
            if (scrollPercent >= 96 && widget && widget.isNavigateFromInfinite) {
              if (typeof binding.value === 'function') {
                binding.value()
              }

              Vue.nextTick(() => {
                setTimeout(() => {
                  let prdEl = document.getElementById(widget.prdId)
                  if (prdEl) {
                    prdEl.scrollIntoView({ behavior: 'smooth', block: 'end' })
                  } else if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
                  }

                  // reset
                  widget.isNavigateFromInfinite = false
                  widget.prdId = ''
                  Vue.ls.set('lastWidgetId', widget)
                }, 700) // small delay for DOM paint
              })
              return
            }
          }
          if (entry.isIntersecting) {
            const scrollY = window.scrollY || window.pageYOffset
            const viewportH = window.innerHeight
            const widgetId = Vue.ls.get('lastWidgetId')
            const targetEl = document.getElementById(widgetId?.id)
            if (targetEl) {
              const targetTop = targetEl.getBoundingClientRect().top + window.scrollY
              // if target position has passed current scroll
              if (scrollY + viewportH >= targetTop) {
                if (typeof binding.value === 'function') {
                  binding.value()
                  return
                }
              }
            }
            if (firstCheck) {
              firstCheck = false
              return
            }
            if (typeof binding.value === 'function') {
              binding.value()
            }
          }
        })
      }, options)

      observer.observe(el)
    })
  }
}



// WEBPACK FOOTER //
// ./src/directives/intersect.js